import type { SkillLevel } from "../../types";
import { SKILL_LEVEL_LABELS, SKILL_LEVEL_COLORS } from "../../types";

interface SkillLevelSelectorProps {
  level: SkillLevel;
  onChange: (level: SkillLevel) => void;
  compact?: boolean;
}

export function SkillLevelSelector({
  level,
  onChange,
  compact = false,
}: SkillLevelSelectorProps) {
  const levels: SkillLevel[] = [0, 1, 2, 3];

  if (compact) {
    return (
      <div className="flex gap-px">
        {levels.map((l) => (
          <button
            key={l}
            onClick={() => onChange(l)}
            className={`
              w-5 h-5 rounded text-[9px] transition-all
              ${level === l ? SKILL_LEVEL_COLORS[l] + " border" : "bg-gray-50 text-gray-300 hover:bg-gray-100"}
            `}
            title={SKILL_LEVEL_LABELS[l]}
          >
            {l || "-"}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex gap-0.5">
      {levels.map((l) => (
        <button
          key={l}
          onClick={() => onChange(l)}
          className={`
            px-1.5 py-0.5 rounded text-[10px] transition-all
            ${level === l ? SKILL_LEVEL_COLORS[l] + " border" : "bg-gray-50 text-gray-400 hover:bg-gray-100"}
          `}
        >
          {SKILL_LEVEL_LABELS[l]}
        </button>
      ))}
    </div>
  );
}
